import { Component, Input, Output, EventEmitter } from '@angular/core';
/* Usage:
<app-on-off-toggle
  [defaultSelection]="false"
  leftOptionText="$"
  rightOptionText="Units"
  (updateSelection)="getSelection($event)">
</app-on-off-toggle> */

@Component({
    selector: 'app-on-off-toggle',
    templateUrl: './on-off-toggle.component.html',
    styleUrls: ['./on-off-toggle.component.scss'],
    standalone: false
})
export class OnOffToggleComponent {
  @Input() defaultSelection = false;
  @Input() leftOptionText = 'Off';
  @Input() rightOptionText = 'On';
  @Output() updateSelection = new EventEmitter<boolean>();
}
